import React, { useState } from 'react';
import './css/services.css';

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="faq-item">
      <div onClick={toggle} className="faq-question">
        <strong>{question}</strong>
        <span>{isOpen ? '▲' : '▼'}</span>
      </div>
      {isOpen && (
        <div className="faq-answer">
          {answer}
        </div>
      )}
    </div>
  );
};

const FAQList = () => {
  const faqs = [
     {
    question: 'What graphic design services do you offer?',
    answer: 'We design social media creatives, logos, brochures, flyers, website banners, infographics, business cards, and more.',
  },
  {
    question: 'Can I request revisions on the designs?',
    answer: 'Yes, we offer multiple rounds of revisions to ensure the final output meets your expectations.',
  },
  {
    question: 'Do you follow brand guidelines?',
    answer: 'Absolutely. We adhere strictly to your brand\'s color schemes, fonts, logo usage, and tone to maintain consistency.',
  },
  {
    question: 'Do you offer packaging or print design as well?',
    answer: 'Yes. We handle both digital and print design including product packaging, signage, roll-ups, and corporate stationary.',
  },
  {
    question: 'How soon can I get my designs?',
    answer: 'Design timelines vary by project scope, but standard turnaround for social media or banners is 1–3 business days.',
  },
  {
    question: 'Can you create custom illustrations or animated designs?',
    answer: 'Yes, our team includes illustrators and motion designers for customized and dynamic visuals.',
  },
    // Add more questions and answers as needed
  ];

  return (
    <div>
      {faqs.map((faq, index) => (
        <FAQItem key={index} question={faq.question} answer={faq.answer} />
      ))}
    </div>
  );
};

const App = () => {
  return (
    <div style={{ padding: '5%' }}>
      <div className="seo-main-faq">
    <div className="seo-main-heading">
      <h1>FAQ’S</h1>
    </div>
      <div className="seo-main-para">
        <p></p>
      </div>
      </div>
      <FAQList />
    </div>
  );
};

export default App;
